import { logError } from "common/error";
import { Waiter } from "common/promises";
import { MAXIMUM_HEIGHT, MAXIMUM_WIDTH } from "common/screen";
import * as PIXI from "pixi.js";
export class Button {
    constructor(config) {
        this.buttonAnimationWaiter = null;
        const { hitArea } = config;
        if (config.hideButtonWhenclick !== false) {
            config.hideButtonWhenclick = true;
        }
        this.config = config;
        this.onDown = this.onDown.bind(this);
        this.state = new State();
        this.sprite = new PIXI.Sprite(this.config.textures[0]);
        this.sprite.interactive = true;
        this.sprite.buttonMode = true;
        this.sprite.hitArea = new PIXI.Rectangle(hitArea.x - MAXIMUM_WIDTH / 2, hitArea.y - MAXIMUM_HEIGHT / 2, hitArea.w || 120, hitArea.h || 120);
        this.sprite.on("mousedown", this.onDown);
        this.sprite.on("touchstart", this.onDown);
    }
    async onDown() {
        this.buttonAnimationWaiter = new Waiter();
        try {
            if (this.state.state !== "idle") {
                return;
            }
            this.state.state = "clicked";
            this.sprite.texture = this.config.textures[1];
            let wait;
            if (this.callback) {
                wait = this.callback();
            }
            else {
                wait = Promise.resolve(null);
            }
            await this.config.pixiContext.delay(100);
            if (this.config.hideButtonWhenclick) {
                await this.config.pixiContext.animate({
                    start: 1,
                    destination: 0,
                    durationMS: 100,
                    setter: (value) => {
                        this.sprite.alpha = value;
                    },
                });
                this.sprite.visible = false;
                this.sprite.texture = this.config.textures[0];
                await wait;
                this.sprite.alpha = 0;
                this.sprite.visible = true;
                await this.config.pixiContext.animate({
                    start: 0,
                    destination: 1,
                    durationMS: 100,
                    setter: (value) => {
                        this.sprite.alpha = value;
                    },
                });
            }
            else {
                this.sprite.texture = this.config.textures[0];
            }
            this.state.state = "idle";
            this.buttonAnimationWaiter.trigger();
            this.buttonAnimationWaiter = null;
        }
        catch (err) {
            logError(err);
            this.buttonAnimationWaiter = null;
        }
    }
    async dispose() {
        this.sprite.interactive = false;
        if (this.buttonAnimationWaiter != null) {
            await this.buttonAnimationWaiter.wait();
        }
    }
    disable() {
        this.sprite.interactive = false;
    }
}
class State {
    constructor() {
        this.state = "idle";
    }
}
//# sourceMappingURL=button.js.map